(function () {
  function defineVideoShowcaseCarousel() {
    if (!customElements.get('slider-component')) {
      setTimeout(defineVideoShowcaseCarousel, 100);
      return;
    }
    if (customElements.get('video-showcase-carousel')) return;

    class VideoShowcaseCarousel extends customElements.get('slider-component') {
      constructor() {
        super();
        this.overlay = this.querySelector('.video-showcase__overlay');
        this.overlayVideo = this.querySelector('.video-showcase__overlay-video');
        this.overlayCloseBtn = this.querySelector('.video-showcase__overlay-close');
        this.overlayContent = this.querySelector('.video-showcase__overlay-content');
        this.overlayProductLink = this.querySelector('.video-showcase__overlay-product');
        this.overlayProductImage = this.querySelector('.video-showcase__overlay-product-image');
        this.overlayProductTitle = this.querySelector('.video-showcase__overlay-product-title');
        this.overlayProductPrice = this.querySelector('.video-showcase__overlay-product-price');

        this.querySelectorAll('.video-showcase__video-card').forEach((card) => {
          card.addEventListener('click', () => this.openOverlay(card));
        });

        this.overlayCloseBtn?.addEventListener('click', () => this.closeOverlay());
        this.overlay?.addEventListener('click', (e) => {
          const isInsideContent = e.target.closest('.video-showcase__overlay-content');
          const isCloseBtn = e.target.closest('.video-showcase__overlay-close');
          if (!isInsideContent && !isCloseBtn) this.closeOverlay();
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.overlay && !this.overlay.hidden) this.closeOverlay();
        });

        this._setFooterBarHeight();
        window.addEventListener('load', () => this._setFooterBarHeight());
        window.addEventListener('resize', () => this._setFooterBarHeight());

        this._observeVideos();
      }

      _observeVideos() {
        // Vídeo só toca quando o card está de fato visível na página —
        // parado tanto quando o usuário arrasta o carrossel pro lado
        // quanto quando rola a página e sai da seção. Sem isso, todo
        // vídeo (mesmo fora da tela) carregava e tocava junto na
        // abertura da página, pesando o carregamento.
        const videos = this.querySelectorAll('.video-showcase__video');
        if (!videos.length) return;
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.play().catch(() => {});
              } else {
                entry.target.pause();
              }
            });
          },
          { threshold: 0.5 }
        );
        videos.forEach((video) => observer.observe(video));
      }

      _setFooterBarHeight() {
        // Site tem um menu inferior fixo no mobile (.footer-bar-mobile) que pode
        // encostar no card do produto do overlay; reserva esse espaço.
        const footerBar = document.querySelector('.footer-bar-mobile');
        const height = footerBar ? footerBar.offsetHeight : 0;
        document.documentElement.style.setProperty('--video-showcase-footerbar-h', height + 'px');
      }

      openOverlay(card) {
        const videoSrc = card.getAttribute('data-video-url');
        if (videoSrc) {
          this.overlayVideo.src = videoSrc;
          this.overlayVideo.muted = false;
          this.overlayVideo.loop = true;
          // Clique é um gesto do usuário, então navegadores permitem autoplay
          // com som aqui. Se algum navegador bloquear mesmo assim, cai pro
          // fallback mudo em vez de travar o vídeo sem tocar nada.
          this.overlayVideo.play().catch(() => {
            this.overlayVideo.muted = true;
            this.overlayVideo.play().catch(() => {});
          });
        }

        this.overlayProductImage.src = card.getAttribute('data-product-image') || '';
        this.overlayProductTitle.textContent = card.getAttribute('data-product-title') || '';
        this.overlayProductPrice.innerHTML = card.getAttribute('data-product-price-html') || '';
        this.overlayProductLink.href = card.getAttribute('data-product-url') || '#';

        this.overlay.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      closeOverlay() {
        if (!this.overlay) return;
        this.overlay.hidden = true;
        this.overlayVideo.pause();
        this.overlayVideo.removeAttribute('src');
        this.overlayVideo.load();
        document.body.style.overflow = '';
      }
    }

    customElements.define('video-showcase-carousel', VideoShowcaseCarousel);
  }

  defineVideoShowcaseCarousel();
})();
